import { createContext, useContext } from "react";

export const DisplaySettingsContext = createContext<{
  editMode: boolean;
}>({ editMode: false });

export const useDisplaySettings = () => {
  const context = useContext(DisplaySettingsContext);
  if (!context) {
    throw new Error(
      "useDisplaySettings must be used within a DisplaySettingsContext"
    );
  }
  return context;
};
